module.exports = __webpack_public_path__ + "static/img/gongdanchuli.3dd57044.png";